/* Softest Hours — storefront behaviour.
   Ports the DreamWrap PDP and Sleep Foundations logic from the Claude Design
   handoff to vanilla JS. Everything degrades to a readable static page with
   JS off: forms post to /cart, details/summary open natively, <dialog> falls
   back to a plain block. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Format like Shopify's own money filter. The template renders 1234.56 with | money and
     hands it over as a sample, so symbol position and separators match the market exactly
     (e.g. $1,234.56 in the US, €1.234,56 in Europe). Falls back to Intl if no sample. */
  function money(cents, cur, loc, sample) {
    if (sample) {
      var a = sample.indexOf('1'), b = sample.lastIndexOf('56');
      if (a > -1 && b > a) {
        var core = sample.slice(a, b + 2), m = core.match(/^1(\D?)234(\D)56$/);
        if (m) {
          var thou = m[1], dec = m[2], n = Math.round(cents);
          var whole = String(Math.floor(n / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, thou);
          var frac = String(n % 100); if (frac.length < 2) frac = '0' + frac;
          return sample.slice(0, a) + whole + dec + frac + sample.slice(b + 2);
        }
      }
    }
    try { return (cents / 100).toLocaleString(loc || 'en', { style: 'currency', currency: cur || 'USD' }); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function esc(v) {
    return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  /* Horizon scrolls .page-wrapper at wider widths and the document below them,
     so both are pinned while a drawer is open. */
  function lock(on) {
    var els = [document.body, document.documentElement];
    document.querySelectorAll('.page-wrapper').forEach(function (el) { els.push(el); });
    els.forEach(function (el) { el.style.overflow = on ? 'hidden' : ''; });
  }
  function bound(el) { if (el.getAttribute('data-bound')) return true; el.setAttribute('data-bound', '1'); return false; }

  /* ---------- header: mobile menu drawer ---------- */
  function menu(root) {
    if (bound(root)) return;
    /* the sticky group scrolls its top bars away and settles with the header at the top */
    var group = document.getElementById('header-group');
    var section = root.closest('.shopify-section') || root;
    function above() {
      if (!group) return;
      var h = 0;
      for (var i = 0; i < group.children.length; i++) { var el = group.children[i]; if (el === section) break; h += el.offsetHeight; }
      group.style.setProperty('--sh-above-h', h + 'px');
    }
    above(); window.addEventListener('resize', above); window.addEventListener('load', above);
    var drawer = root.querySelector('[data-menu-drawer]');
    var btn = root.querySelector('[data-menu-open]');
    if (!drawer || !btn) return;
    var opener = null;
    function drawerTop() {
      /* the panel starts right under the sticky header, like the reference */
      var g = document.getElementById('header-group') || section;
      var b = g.getBoundingClientRect();
      drawer.style.setProperty('--sh-drawer-top', Math.max(0, Math.round(b.bottom)) + 'px');
    }
    function open() { opener = document.activeElement; drawerTop(); drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); btn.setAttribute('aria-expanded', 'true'); lock(true); var x = drawer.querySelector('[data-menu-close]'); if (x) x.focus(); }
    function close() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); btn.setAttribute('aria-expanded', 'false'); lock(false); if (opener && opener.focus) opener.focus(); }
    btn.addEventListener('click', open);
    drawer.querySelectorAll('[data-menu-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
  }

  /* ---------- country and currency dropdown ---------- */
  function loc(root) {
    if (bound(root)) return;
    var btn = root.querySelector('[data-loc-toggle]');
    var panel = root.querySelector('[data-loc-menu]');
    if (!btn || !panel) return;
    var search = root.querySelector('[data-loc-search]');
    var none = root.querySelector('[data-loc-none]');
    var rows = panel.querySelectorAll('li');
    function show(on) { panel.hidden = !on; btn.setAttribute('aria-expanded', on ? 'true' : 'false'); }
    function filter() {
      var q = (search && search.value || '').trim().toLowerCase(), hits = 0;
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        if (row.hasAttribute('data-loc-group')) { row.hidden = q !== ''; continue; }
        var hit = !q || row.textContent.toLowerCase().indexOf(q) !== -1;
        row.hidden = !hit; if (hit) hits++;
      }
      if (none) none.hidden = hits > 0;
    }
    if (search) { search.addEventListener('input', filter); search.addEventListener('click', function (e) { e.stopPropagation(); }); }
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var opening = panel.hidden;
      show(opening);
      if (opening && search) { search.value = ''; filter(); if (window.matchMedia('(min-width: 861px)').matches) search.focus(); }
    });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) show(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') show(false); });
  }

  /* ---------- the bag ----------
     One drawer for the whole site. Every add-to-cart form is intercepted so a
     page never navigates to /cart just to confirm something was added. */
  function bag() {
    var root = document.querySelector('[data-cart]');
    if (!root || bound(root)) return;
    var scrim = document.querySelector('.sh-cart__scrim');
    var itemsEl = root.querySelector('[data-cart-items]');
    var emptyEl = root.querySelector('[data-cart-empty]');
    var footEl = root.querySelector('[data-cart-foot]');
    var totalEl = root.querySelector('[data-cart-total]');
    var closeBtn = root.querySelector('[data-cart-x]');
    var opener = null;
    var CUR = root.getAttribute('data-currency') || 'USD';
    var LOC = root.getAttribute('data-locale') || 'en';
    var SAMPLE = root.getAttribute('data-money-sample') || '';
    var shipEl = root.querySelector('[data-cart-ship]');
    var shipText = root.querySelector('[data-cart-ship-text]');
    var wasEl = root.querySelector('[data-cart-was]');
    var upEl = root.querySelector('[data-cart-upsell]');
    var upRow = root.querySelector('[data-cart-upsell-row]');
    var COMPARE = (function () { var el = root.querySelector('[data-cart-compare]'); try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } })();
    var SKEL = '<div class="sh-cart__skel" aria-hidden="true"><i></i><div><b></b><b></b><b></b></div></div>';
    var busyTimer = null;
    /* while a fresh add is loading, show a placeholder row instead of the empty state */
    function busy(on) {
      clearTimeout(busyTimer);
      if (on) {
        root.classList.add('is-busy');
        if (itemsEl && !itemsEl.querySelector('.sh-cart__skel')) itemsEl.insertAdjacentHTML('beforeend', SKEL);
        if (emptyEl) emptyEl.hidden = true;
        busyTimer = setTimeout(function () { busy(false); load(); }, 8000);
      } else {
        root.classList.remove('is-busy');
        var sk = itemsEl && itemsEl.querySelector('.sh-cart__skel'); if (sk) sk.remove();
      }
    }
    var upData = (function () { var el = root.querySelector('[data-cart-upsell-data]'); try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; } })();
    var TRASH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>';
    var TAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.6 13.4 12 22l-9-9V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.3"/></svg>';

    /* the empty state splits grey/white exactly on the middle of the cart circle */
    function splitLine() {
      var empty = root.querySelector('[data-cart-empty]'), icon = root.querySelector('.sh-cart__emptyicon');
      if (!empty || !icon) return;
      var e = empty.getBoundingClientRect(), i = icon.getBoundingClientRect();
      if (i.height) empty.style.setProperty('--sh-split', Math.round(i.top - e.top + i.height / 2) + 'px');
    }
    window.addEventListener('resize', splitLine);

    function open() { opener = document.activeElement; root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false'); if (scrim) scrim.classList.add('is-open'); lock(true); if (closeBtn) closeBtn.focus(); load(); setTimeout(splitLine, 60); }
    function close() { root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true'); if (scrim) scrim.classList.remove('is-open'); lock(false); if (opener && opener.focus) opener.focus(); }
    function counts(n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = n; if (n) el.removeAttribute('data-zero'); else el.setAttribute('data-zero', '');
      });
    }
    function load() { fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(render).catch(function () {}); }
    function render(cart) {
      if (!itemsEl) return;
      busy(false);
      counts(cart.item_count);
      if (shipEl) shipEl.hidden = !cart.item_count;
      if (!cart.item_count) { itemsEl.innerHTML = ''; if (emptyEl) emptyEl.hidden = false; if (footEl) footEl.hidden = true; return; }
      if (emptyEl) emptyEl.hidden = true; if (footEl) footEl.hidden = false;

      /* free shipping progress */
      if (shipEl && shipText) {
        var need = parseInt(root.getAttribute('data-free-ship'), 10) || 0;
        var left = need - cart.total_price;
        var done = need ? Math.max(0, Math.min(100, Math.round(cart.total_price / need * 100))) : 100;
        shipEl.classList.toggle('is-done', left <= 0);
        shipEl.style.setProperty('--sh-ship', done);
        shipText.textContent = left <= 0
          ? (root.getAttribute('data-ship-ok') || 'Your order qualifies for free shipping')
          : (root.getAttribute('data-ship-more') || 'You are [amount] away from free shipping').replace('[amount]', money(left, CUR, LOC, SAMPLE));
      }

      var savingTpl = root.getAttribute('data-saving') || 'You save [amount]';
      itemsEl.innerHTML = cart.items.map(function (it) {
        var url = it.url || ('/products/' + it.handle);
        var img = it.image ? '<img src="' + esc(it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=300') + '" alt="" loading="lazy">' : '';
        var opt = (it.variant_title && it.variant_title !== 'Default Title') ? '<p class="sh-cart__opt">' + esc(it.variant_title) + '</p>' : '';
        /* a deal applied -> line totals (normal price x qty vs what you pay);
           no deal -> per unit against the compare-at price */
        var disc = it.original_line_price - it.final_line_price, was, now, saved;
        if (disc > 0) { was = it.original_line_price; now = it.final_line_price; saved = disc; }
        else {
          was = it.original_price;
          var cmp = COMPARE[String(it.variant_id)] || 0; if (cmp > was) was = cmp;
          now = it.final_price; saved = (was - now) * it.quantity;
        }
        var price = (was > now ? '<s class="sh-cart__was">' + money(was, CUR, LOC, SAMPLE) + '</s> ' : '') + money(now, CUR, LOC, SAMPLE);
        var names = (it.line_level_discount_allocations || []).map(function (d) { return (d.discount_application && d.discount_application.title) || ''; }).filter(Boolean);
        var deal = names.length ? '<p class="sh-cart__dealname">' + esc(names.join(' · ')) + '</p>' : '';
        var save = saved > 0 ? '<p class="sh-cart__deal">' + TAG + '<span>' + esc(savingTpl.replace('[amount]', money(saved, CUR, LOC, SAMPLE)).replace('[title]', names.join(' · '))) + '</span></p>' : '';
        return '<div class="sh-cart__row" data-key="' + esc(it.key) + '" data-unit="' + it.final_price + '">' +
          '<a class="sh-cart__thumb" href="' + esc(url) + '" data-cart-close>' + img + '</a>' +
          '<div><div class="sh-cart__top"><a class="sh-cart__name" href="' + esc(url) + '" data-cart-close>' + esc(it.product_title) + '</a>' +
          '<button type="button" class="sh-cart__kill" data-kill aria-label="Remove">' + TRASH + '</button></div>' + opt +
          '<div class="sh-cart__bot">' +
            '<div class="sh-qty"><button type="button" data-step="-1" aria-label="Decrease quantity">−</button><span data-qty>' + it.quantity + '</span><button type="button" data-step="1" aria-label="Increase quantity">+</button></div>' +
            '<div class="sh-cart__pricebox"><p class="sh-cart__price"><span class="sh-cart__line">' + price + '</span></p>' + deal + '</div>' +
          '</div>' + (save ? '<div class="sh-cart__saverow">' + save + '</div>' : '') + '</div></div>';
      }).join('');

      /* add-ons: everything from the chosen collection that is not in the cart yet */
      if (upEl && upRow) {
        var inCart = cart.items.map(function (i) { return i.handle; });
        var picks = upData.filter(function (p) { return p.available && inCart.indexOf(p.handle) === -1; }).slice(0, 6);
        upEl.hidden = picks.length === 0;
        upRow.innerHTML = picks.map(function (p) {
          var was = p.compare > p.price ? '<s>' + money(p.compare, CUR, LOC, SAMPLE) + '</s> ' : '';
          return '<div class="sh-cart__up">' +
            '<a class="sh-cart__upimg" href="' + esc(p.url) + '" data-cart-close>' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '') +
              (p.img2 ? '<img class="sh-cart__upimg2" src="' + esc(p.img2) + '" alt="" loading="lazy">' : '') + '</a>' +
            '<a class="sh-cart__upname" href="' + esc(p.url) + '" data-cart-close>' + esc(p.title) + '</a>' +
            '<p class="sh-cart__upprice">' + was + money(p.price, CUR, LOC, SAMPLE) + '</p>' +
            '<button type="button" class="sh-btn sh-btn--secondary sh-btn--sm" data-upsell-add="' + p.id + '">' + esc(root.getAttribute('data-upsell-cta') || 'Add to cart') + '</button></div>';
        }).join('');
      }

      if (totalEl) totalEl.textContent = money(cart.total_price, CUR, LOC, SAMPLE);
      if (wasEl) {
        var orig = cart.original_total_price || cart.items_subtotal_price || 0;
        if (orig > cart.total_price) { wasEl.textContent = money(orig, CUR, LOC, SAMPLE); wasEl.hidden = false; }
        else wasEl.hidden = true;
      }
    }

    function retotal(skipKey) {
      var total = 0, count = 0;
      itemsEl.querySelectorAll('.sh-cart__row').forEach(function (row) {
        if (skipKey && row.getAttribute('data-key') === skipKey) return;
        var q = parseInt(row.querySelector('[data-qty]').textContent, 10) || 0;
        total += (parseInt(row.getAttribute('data-unit'), 10) || 0) * q; count += q;
      });
      if (totalEl) totalEl.textContent = money(total, CUR, LOC, SAMPLE);
      if (wasEl) wasEl.hidden = true;
      counts(count);
      if (!count) {
        itemsEl.innerHTML = '';
        if (emptyEl) emptyEl.hidden = false;
        if (footEl) footEl.hidden = true;
        if (upEl) upEl.hidden = true;      /* add-ons belong to a filled cart */
        if (shipEl) shipEl.hidden = true;
        setTimeout(splitLine, 40);
      }
    }
    function setQty(key, qty) {
      fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(render).catch(function () {});
    }
    if (upRow) upRow.addEventListener('click', function (e) {
      var add = e.target.closest('[data-upsell-add]'); if (!add) return;
      add.disabled = true; add.classList.add('is-loading'); busy(true);
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(add.getAttribute('data-upsell-add')), quantity: 1 }) })
        .then(function (r) { return r.json(); }).then(function () { load(); })
        .catch(function () {}).then(function () { add.disabled = false; add.classList.remove('is-loading'); });
    });

    itemsEl.addEventListener('click', function (e) {
      var row = e.target.closest('.sh-cart__row'); if (!row) return;
      var key = row.getAttribute('data-key');
      if (e.target.closest('[data-kill]')) { row.classList.add('is-going'); setTimeout(function () { row.remove(); }, 180); retotal(key); setQty(key, 0); return; }
      var step = e.target.closest('[data-step]'); if (!step) return;
      var qtyEl = row.querySelector('[data-qty]');
      var next = Math.max(0, (parseInt(qtyEl.textContent, 10) || 0) + parseInt(step.getAttribute('data-step'), 10));
      if (!next) { row.classList.add('is-going'); setTimeout(function () { row.remove(); }, 180); retotal(key); }
      else { qtyEl.textContent = next; row.classList.add('is-updating'); }
      setQty(key, next);
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { if (!e.target.closest('a')) e.preventDefault(); close(); return; }
      var t = e.target.closest('[data-cart-open]'); if (t) { e.preventDefault(); open(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      if (form.hasAttribute('data-sh-invalid')) return; /* the PDP form blocks itself when no size is chosen */
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function (j) { if (j && j.status) throw j; busy(true); open(); document.dispatchEvent(new CustomEvent('sh:added', { detail: j })); })
        .catch(function (err) { if (err && err.description) document.dispatchEvent(new CustomEvent('sh:adderror', { detail: err })); else form.submit(); })
        .then(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
    });
    window.addEventListener('pageshow', function () { load(); });
    load();
  }

  /* ---------- country prompt ----------
     Shopify resolves the visitor's country itself. The card only appears when
     the detected country is one we sell to and is not the one already chosen.
     It never switches anything by itself — the visitor decides. */
  var GEO_URL = '/browsing_context_suggestions.json?source=geolocation_recommendation&show_gate=1&country%5Benabled%5D=true&currency%5Benabled%5D=true&language%5Benabled%5D=true';
  function geo(root) {
    if (bound(root)) return;
    var store = 'sh-geo-dismissed';
    try { if (localStorage.getItem(store)) return; } catch (e) {}
    var here = root.getAttribute('data-current'), list;
    try { list = JSON.parse(root.querySelector('[data-geo-countries]').textContent); } catch (e) { return; }
    function fill(tpl, m) {
      return String(tpl || '').replace(/\{country\}/g, m.n).replace(/\{currency\}/g, m.cur + ' ' + m.sym)
        .replace(/\{here_currency\}/g, root.getAttribute('data-here-currency') || '').replace(/\{here\}/g, root.getAttribute('data-here') || '');
    }
    root.querySelectorAll('[data-geo-dismiss]').forEach(function (b) {
      b.addEventListener('click', function () { root.classList.remove('is-in'); setTimeout(function () { root.hidden = true; }, 320); try { localStorage.setItem(store, '1'); } catch (e) {} });
    });
    fetch(GEO_URL, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var s = (j.suggestions || [])[0];
      var code = (s && (s.handle || (s.country && s.country.handle))) || (j.detected_values && j.detected_values.country && j.detected_values.country.handle);
      if (!code || code === here) return;
      var m = null; for (var i = 0; i < list.length; i++) { if (list[i].c === code) { m = list[i]; break; } }
      if (!m) return;
      var flag = root.querySelector('[data-geo-flag]'); if (flag) flag.src = m.f; flag.hidden = !m.f;
      root.querySelector('[data-geo-head]').textContent = fill(root.getAttribute('data-head'), m);
      root.querySelector('[data-geo-sub]').textContent = fill(root.getAttribute('data-sub'), m);
      root.querySelector('[data-geo-go]').textContent = fill(root.getAttribute('data-go'), m);
      root.querySelector('[data-geo-stay]').textContent = fill(root.getAttribute('data-stay'), m);
      root.querySelector('[data-geo-input]').value = m.c;
      root.hidden = false;
      requestAnimationFrame(function () { root.classList.add('is-in'); });
    }).catch(function () {});
  }

  /* ---------- hero carousel: auto-advance, progress line, swipe ---------- */
  function hero(root) {
    if (bound(root)) return;
    var slides = root.querySelectorAll('[data-hero-slide]'), dots = root.querySelectorAll('[data-hero-dot]');
    if (slides.length < 2) return;
    var i = 0, timer = null, raf = null, t0 = 0, DUR = parseInt(root.getAttribute('data-interval'), 10) || 3000;
    function hydrate(s) {
      if (!s) return;
      s.querySelectorAll('img[data-src]').forEach(function (im) {
        if (im.getAttribute('data-srcset')) im.srcset = im.getAttribute('data-srcset');
        im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); im.removeAttribute('data-srcset');
      });
    }
    if (document.readyState === 'complete') slides.forEach(hydrate);
    else window.addEventListener('load', function () { slides.forEach(hydrate); });
    function paint() {
      hydrate(slides[i]);
      slides.forEach(function (s, n) { s.classList.toggle('is-on', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); d.setAttribute('aria-selected', n === i ? 'true' : 'false'); d.style.setProperty('--sh-progress', '0%'); });
    }
    function tick(now) {
      var pct = Math.min(100, ((now - t0) / DUR) * 100);
      var d = dots[i]; if (d) d.style.setProperty('--sh-progress', pct + '%');
      if (pct < 100) raf = requestAnimationFrame(tick);
    }
    function go(n) { i = (n + slides.length) % slides.length; paint(); start(); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } if (raf) { cancelAnimationFrame(raf); raf = null; } }
    function start() {
      stop(); if (reduce) return;
      t0 = performance.now(); raf = requestAnimationFrame(tick);
      timer = setInterval(function () { i = (i + 1) % slides.length; paint(); t0 = performance.now(); if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(tick); }, DUR);
    }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.changedTouches[0].screenX; y0 = e.changedTouches[0].screenY; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = x0 - e.changedTouches[0].screenX, dy = y0 - e.changedTouches[0].screenY;
      if (Math.abs(dx) > 56 && Math.abs(dx) > Math.abs(dy) * 1.6) go(dx > 0 ? i + 1 : i - 1);
      x0 = null; y0 = null;
    }, { passive: true });
    paint(); start();
  }

  /* ---------- tab rails ---------- */
  function tabs(root) {
    if (bound(root)) return;
    var btns = root.querySelectorAll('[data-tab]');
    var panels = root.querySelectorAll('[data-tab-panel]');
    if (!btns.length) return;
    function pick(id) {
      btns.forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-tab') === id ? 'true' : 'false'); });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-tab-panel') !== id; });
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { pick(b.getAttribute('data-tab')); }); });
  }

  /* ---------- rails: arrows scroll the track ---------- */
  function rail(root) {
    if (bound(root)) return;
    var track = root.querySelector('[data-rail-track]');
    if (!track) return;
    root.querySelectorAll('[data-rail-prev],[data-rail-next]').forEach(function (b) {
      b.addEventListener('click', function () {
        var card = track.firstElementChild; var w = card ? card.getBoundingClientRect().width + 20 : 260;
        track.scrollBy({ left: b.hasAttribute('data-rail-next') ? w : -w, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }

  /* ---------- quantity stepper ---------- */
  function qty(root) {
    if (bound(root)) return;
    var input = root.querySelector('input'); var minus = root.querySelector('[data-step="-1"]'); var plus = root.querySelector('[data-step="1"]');
    if (!input) return;
    var min = parseInt(input.min, 10) || 1, max = parseInt(input.max, 10) || 99;
    function set(n) { n = Math.min(max, Math.max(min, n)); input.value = n; if (minus) minus.disabled = n <= min; if (plus) plus.disabled = n >= max; input.dispatchEvent(new Event('change', { bubbles: true })); }
    if (minus) minus.addEventListener('click', function () { set((parseInt(input.value, 10) || min) - 1); });
    if (plus) plus.addEventListener('click', function () { set((parseInt(input.value, 10) || min) + 1); });
    input.addEventListener('blur', function () { set(parseInt(input.value, 10) || min); });
    set(parseInt(input.value, 10) || min);
  }

  /* ---------- PDP ----------
     Colour and size are explicit selections. Size is required and starts
     unselected (the design's rule), so the price shows a range until chosen.
     Colour swaps the gallery to that colour's media. */
  /* Same maths as the checkout function (extensions/bundle-discount): threshold tiers (k = 0) give a percentage on every
     unit, set tiers (k > 0) reward k units per set, largest sets first; the customer gets whichever saves more.
     Discounts are per unit and rounded down, like Shopify does. */
  function bundleSaving(tiers, q, cents) { var u = []; for (var i = 0; i < q; i++) u.push(cents); return bundleSavingUnits(tiers, u); }
  /* units = one price (in cents) per item. Set rewards go to the cheapest items, biggest reward first. */
  function bundleSavingUnits(tiers, units) {
    var q = units.length, pct = 0, rem = q, rewards = [], a = 0, b = 0;
    tiers.forEach(function (t) { if (!t.k && q >= t.min && t.off > pct) pct = t.off; });
    units.forEach(function (c) { a += Math.floor(c * pct / 100); });
    tiers.filter(function (t) { return t.k > 0; }).sort(function (x, y) { return y.min - x.min; }).forEach(function (t) {
      var n = Math.floor(rem / t.min); rem -= n * t.min; for (var i = 0; i < n * t.k; i++) rewards.push(t.off);
    });
    rewards.sort(function (x, y) { return y - x; });
    units.slice().sort(function (x, y) { return x - y; }).forEach(function (c, i) { if (i < rewards.length) b += Math.floor(c * rewards[i] / 100); });
    return Math.max(a, b);
  }

  function pdp(root) {
    if (bound(root)) return;
    var dataEl = root.querySelector('[data-sh-product]');
    if (!dataEl) return;
    var P; try { P = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var CUR = P.currency, LOC = P.locale, SAMPLE = P.moneySample || '';
    var colourIdx = -1, sizeIdx = -1;
    P.options.forEach(function (o, i) { var n = String(o.name || o).toLowerCase(); if (n === 'color' || n === 'colour' || n === 'farbe' || n === 'kleur') colourIdx = i; if (n === 'size' || n === 'größe' || n === 'grosse' || n === 'maat') sizeIdx = i; });
    function optName(i) { var o = P.options[i]; return o && o.name ? o.name : o; }
    function optValues(i) { var o = P.options[i]; if (o && o.values) return o.values; var seen = []; P.variants.forEach(function (v) { if (seen.indexOf(v.o[i]) < 0) seen.push(v.o[i]); }); return seen; }

    var form = root.querySelector('form[action*="/cart/add"]');
    var idInput = root.querySelector('[data-variant-input]');
    var priceNow = root.querySelector('[data-price-now]');
    var priceWas = root.querySelector('[data-price-was]');
    var priceOff = root.querySelector('[data-price-off]');
    var priceNote = root.querySelector('[data-price-note]');
    var tiers = (function () { try { return JSON.parse(root.getAttribute('data-tiers') || '[]'); } catch (e) { return []; } })();
    var ctaBtn = root.querySelector('[data-buy-button]');
    var ctaLbl = root.querySelector('[data-buy-label]');
    var errEl = root.querySelector('[data-form-error]');
    var okEl = root.querySelector('[data-form-ok]');
    var colourName = root.querySelector('[data-colour-name]');
    var washer = root.querySelector('[data-washer]');
    var stock = root.querySelector('[data-stock]');
    var sticky = document.querySelector('[data-sticky]');
    var stickyPrice = sticky && sticky.querySelector('[data-sticky-price]');
    var stickySum = sticky && sticky.querySelector('[data-sticky-summary]');
    var stickyBtn = sticky && sticky.querySelector('[data-sticky-buy]');
    var stickyWas = sticky && sticky.querySelector('[data-sticky-was]');
    var qtyInput = root.querySelector('[data-qty-input]');

    /* One slot per product option, in the product's own order; null = the customer still has to choose.
       Colour, an option that is not shown and an option with a single value start on a value; the rest start empty. */
    var sel = P.options.map(function () { return null; });
    var state = { colour: null, size: null };
    var optBtns = [].slice.call(root.querySelectorAll('[data-opt]'));
    var preset = root.getAttribute('data-preselect-size') === 'true';
    var shownIdx = []; optBtns.forEach(function (b) { var i = +b.getAttribute('data-opt'); if (shownIdx.indexOf(i) < 0) shownIdx.push(i); });

    /* starting point = the selected variant (URL ?variant=) or the first one */
    var initial = P.variants.filter(function (v) { return v.id === P.selected; })[0] || P.variants[0];
    P.options.forEach(function (_, i) {
      var auto = i === colourIdx || shownIdx.indexOf(i) < 0 || optValues(i).length < 2;
      if (initial && (auto || preset || P.selectedExplicit)) sel[i] = initial.o[i];
    });
    function syncState() { state.colour = colourIdx > -1 ? sel[colourIdx] : null; state.size = sizeIdx > -1 ? sel[sizeIdx] : null; }
    syncState();

    /* a null in the list is a wildcard, so a half-finished choice still narrows the variants down */
    function matchAll(s) { return P.variants.filter(function (v) { return s.every(function (x, i) { return x === null || v.o[i] === x; }); }); }
    function match(s) { return matchAll(s)[0] || null; }
    function complete() { return sel.every(function (x) { return x !== null; }); }
    function ctrl(i, val) { return root.querySelector('[data-opt="' + i + '"][data-val="' + String(val).replace(/"/g, '\\"') + '"]'); }
    function optLabel(i, val) { var b = ctrl(i, val); b = b && b.querySelector('b'); return b ? b.textContent : val; }
    function range(list) {
      var min = Infinity, max = -Infinity;
      list.forEach(function (v) { if (v.price < min) min = v.price; if (v.price > max) max = v.price; });
      if (min === Infinity) return '';
      return min === max ? money(min, CUR, LOC, SAMPLE) : money(min, CUR, LOC, SAMPLE) + ' – ' + money(max, CUR, LOC, SAMPLE);
    }
    function setStatus(el, msg) { if (!el) return; if (msg) { el.querySelector('span').textContent = msg; el.hidden = false; } else el.hidden = true; }

    function paint() {
      var v = complete() ? match(sel) : null;
      optBtns.forEach(function (b) {
        var i = +b.getAttribute('data-opt'), val = b.getAttribute('data-val');
        b.setAttribute('aria-pressed', sel[i] === val ? 'true' : 'false');
        if (i === colourIdx) return;                                   /* colour stays clickable: it swaps the gallery */
        var t = sel.slice(); t[i] = val;
        var cand = matchAll(t).filter(function (x) { return x.available; })[0];
        b.disabled = !cand;
        b.title = cand ? '' : (b.getAttribute('data-unavailable-label') || 'Unavailable');
      });
      if (colourName) colourName.textContent = state.colour || '';
      if (washer) {
        var w = state.size ? root.querySelector('[data-washer-for="' + CSS.escape(state.size) + '"]') : null;
        washer.textContent = w ? w.textContent : washer.getAttribute('data-default');
      }
      var label;
      if (v) {
        idInput.value = v.id;
        priceNow.textContent = money(v.price, CUR, LOC, SAMPLE);
        var hasOff = v.compare && v.compare > v.price;
        if (priceWas) { if (hasOff) { priceWas.textContent = money(v.compare, CUR, LOC, SAMPLE); priceWas.hidden = false; } else priceWas.hidden = true; }
        if (priceOff) { if (hasOff) { priceOff.textContent = Math.round((v.compare - v.price) / v.compare * 100) + (priceOff.getAttribute('data-suffix') || '% OFF'); priceOff.hidden = false; } else priceOff.hidden = true; }
        if (stickyWas) { if (hasOff) { stickyWas.textContent = money(v.compare, CUR, LOC, SAMPLE); stickyWas.hidden = false; } else stickyWas.hidden = true; }
        var qn = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        /* volume tiers are applied automatically at checkout, so the button shows the real total */
        label = v.available ? (ctaBtn.getAttribute('data-label-available') + ' — ' + money(v.price * qn - bundleSaving(tiers, qn, v.price), CUR, LOC, SAMPLE)) : ctaBtn.getAttribute('data-label-soldout');
        ctaBtn.disabled = !v.available;
        if (stock) { stock.hidden = false; stock.classList.toggle('is-out', !v.available); stock.querySelector('span').textContent = v.available ? stock.getAttribute('data-in') : stock.getAttribute('data-out'); }
        if (priceNote) priceNote.hidden = !priceNote.getAttribute('data-always');
      } else {
        priceNow.textContent = range(matchAll(sel));
        if (priceWas) priceWas.hidden = true;
        if (priceOff) priceOff.hidden = true;
        if (stickyWas) stickyWas.hidden = true;
        label = ctaBtn.getAttribute('data-label-available');
        ctaBtn.disabled = false;
        if (stock) stock.hidden = true;
        if (priceNote) priceNote.hidden = false;
      }
      ctaLbl.textContent = label;
      if (stickyPrice) stickyPrice.textContent = v ? money(v.price, CUR, LOC, SAMPLE) : selectLabel();
      if (stickySum) stickySum.textContent = shownIdx.map(function (i) { return sel[i] ? optLabel(i, sel[i]) : chooseFor(i); }).join(' / ');
      form.toggleAttribute('data-sh-invalid', !complete());
      document.dispatchEvent(new CustomEvent('sh:variant', { detail: { colour: state.colour, size: state.size, options: sel.slice(), variant: v } }));
      /* colour → gallery */
      if (v && v.media) jumpTo(v.media);
      else if (!v && sel.some(function (x) { return x !== null; })) { var any = matchAll(sel)[0]; if (any && any.media) jumpTo(any.media); }
      try { if (v) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u); } } catch (e) {}
    }
    /* copy for an option the customer has not chosen yet: the size settings for size, the generic ones with [option] for the rest */
    function missingIdx() { for (var i = 0; i < sel.length; i++) { if (sel[i] === null) return i; } return -1; }
    function fill(t, i) { return String(t || '').replace('[option]', String(optName(i)).toLowerCase()); }
    function chooseFor(i) {
      if (i === sizeIdx && sticky && sticky.getAttribute('data-choose-label')) return sticky.getAttribute('data-choose-label');
      return fill(root.getAttribute('data-option-choose') || 'choose a [option]', i);
    }
    function selectLabel() {
      var i = missingIdx();
      if ((i < 0 || i === sizeIdx) && sticky) return sticky.getAttribute('data-select-label') || 'Select a size';
      var t = chooseFor(i);
      return t.charAt(0).toUpperCase() + t.slice(1);
    }

    optBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        sel[+b.getAttribute('data-opt')] = b.getAttribute('data-val');
        syncState(); setStatus(errEl, ''); setStatus(okEl, ''); paint();
      });
    });
    /* colour tiles elsewhere on the page (colour editorial section) */
    document.addEventListener('sh:pickcolour', function (e) {
      var c = e.detail; var sw = colourIdx > -1 ? ctrl(colourIdx, c) : null;
      if (sw && !sw.disabled) { sel[colourIdx] = c; syncState(); paint(); }
    });

    /* bundle tiers: a tier button sets the quantity, the matching tier is marked while the quantity changes */
    var tierBtns = [].slice.call(root.querySelectorAll('[data-offer-tier]'));
    function paintTiers() {
      if (!tierBtns.length) return;
      var qn = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1, best = null;
      tierBtns.forEach(function (b) { var m = parseInt(b.getAttribute('data-min'), 10) || 0; if (qn >= m && (!best || m > (parseInt(best.getAttribute('data-min'), 10) || 0))) best = b; });
      tierBtns.forEach(function (b) { var on = b === best; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    }
    function setQty(n) {
      if (!qtyInput) return;
      qtyInput.value = Math.min(parseInt(qtyInput.max, 10) || 99, n);
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('blur'));
    }
    var offerEl = root.querySelector('[data-offer][data-picker]');
    tierBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var m = parseInt(b.getAttribute('data-min'), 10) || 1;
        setQty(m);
        if (offerEl) bundlePicker(m, b, true);
      });
    });
    var pickBtn = root.querySelector('[data-offer-pick]');
    if (pickBtn) pickBtn.addEventListener('click', function () {
      var qn = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1, first = tierBtns.length ? parseInt(tierBtns[0].getAttribute('data-min'), 10) || 2 : 2;
      bundlePicker(Math.max(qn, first), pickBtn, false);
    });

    /* ---------- mix & match picker ----------
       One sheet, one row per item: every item gets its own colour/size, the footer shows the live total with the
       bundle saving (same maths as the checkout function) and everything is added to the cart in one request. */
    var bp = null, bpSaved = null;   /* the customer's picks survive closing the sheet; they reset once added to the cart */
    document.addEventListener('sh:added', function () { bpSaved = null; });
    /* The cart is the memory once something was added: reopening shows exactly those items and the button updates
       the cart instead of adding the same items again. Unsaved picks (bpSaved) win over the cart while they exist. */
    function bundlePicker(count, opener, exact) {
      var done = false;
      function go(cart) { if (done) return; done = true; openPicker(count, opener, exact, cart); }
      fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(go).catch(function () { go(null); });
      setTimeout(function () { go(null); }, 1500);
    }
    function openPicker(count, opener, exact, cart) {
      var T = function (k, d) { return offerEl.getAttribute('data-picker-' + k) || d; };
      var MAX = qtyInput ? parseInt(qtyInput.max, 10) || 9 : 9;
      var firstOk = P.variants.filter(function (v) { return v.available; })[0] || P.variants[0];
      var cur = match(sel);
      var base = (cur && cur.available ? cur : firstOk).o.slice();
      if (colourIdx > -1 && state.colour) { var vc = P.variants.filter(function (v) { return v.available && v.o[colourIdx] === state.colour; })[0]; if (vc && !(cur && cur.available)) base = vc.o.slice(); }
      function match(o) { return P.variants.filter(function (v) { return v.o.every(function (x, i) { return x === o[i]; }); })[0] || null; }
      function swatchStyle(val) { var s = colourIdx > -1 ? ctrl(colourIdx, val) : null; return s ? s.getAttribute('style') || '' : ''; }
      function optHtml(i, val) { var s = ctrl(i, val); return s ? s.innerHTML : '<b>' + esc(val) + '</b>'; }
      /* reopen with the earlier picks: a deal tap resizes them to that deal, the link leaves them as they were */
      var inCart = [], cartIds = [];
      ((cart && cart.items) || []).forEach(function (it) {
        if (it.product_id !== P.id) return;
        var v = P.variants.filter(function (x) { return x.id === it.variant_id; })[0]; if (!v) return;
        cartIds.push(v.id); for (var n = 0; n < it.quantity; n++) inCart.push(v.o.slice());
      });
      var editing = inCart.length > 0;
      var slots = (bpSaved || inCart).filter(function (o) { var v = match(o); return v && v.available; }).slice(0, MAX), openIdx = 0;
      /* a deal tap resizes unsaved picks to that deal, but never drops items that are already in the cart */
      var want = Math.min(MAX, Math.max(1, slots.length && (!exact || (editing && count < slots.length)) ? slots.length : count));
      while (slots.length < want) slots.push((slots[slots.length - 1] || base).slice());
      slots.length = want;
      bpSaved = slots;
      if (!bp) {
        bp = document.createElement('div'); bp.className = 'sh sh-qa sh-bp';
        bp.innerHTML = '<div class="sh-qa__scrim" data-bp-close></div><aside class="sh-qa__panel" role="dialog" aria-modal="true">' +
          '<div class="sh-qa__top"><h2 data-bp-title></h2><button type="button" class="sh-iconbtn" data-bp-close aria-label="Close">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button></div>' +
          '<div class="sh-qa__body sh-bp__body" data-bp-body></div><div class="sh-bp__foot" data-bp-foot></div></aside>';
        document.body.appendChild(bp);
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && bp.classList.contains('is-open')) bp._close(); });
        document.addEventListener('sh:added', function () { if (bp.classList.contains('is-open')) { bp.classList.remove('is-open'); } });
      }
      var bodyEl = bp.querySelector('[data-bp-body]'), footEl = bp.querySelector('[data-bp-foot]');
      bp.querySelector('[data-bp-title]').textContent = T('title', 'Build your bundle');
      bp.querySelector('.sh-qa__panel').setAttribute('aria-label', T('title', 'Build your bundle'));
      bp._close = function () { bp.classList.remove('is-open'); lock(false); if (opener && opener.focus) opener.focus(); };

      function summary(o) { return o.filter(function (x) { return x && x !== 'Default Title'; }).join(' · '); }
      function draw() {
        var html = '';
        slots.forEach(function (o, n) {
          var v = match(o), isOpen = n === openIdx;
          html += '<section class="sh-bp__item' + (isOpen ? ' is-open' : '') + '" data-bp-item="' + n + '">' +
            '<button type="button" class="sh-bp__head" data-bp-toggle="' + n + '" aria-expanded="' + (isOpen ? 'true' : 'false') + '">' +
            (colourIdx > -1 ? '<span class="sh-bp__dot" style="' + esc(swatchStyle(o[colourIdx])) + '"></span>' : '') +
            '<span class="sh-bp__meta"><b>' + esc(T('item', 'Item [n]').replace('[n]', n + 1)) + '</b><span>' + esc(summary(o)) + '</span></span>' +
            '<span class="sh-bp__price">' + (v ? money(v.price, CUR, LOC, SAMPLE) : '') + '</span>' +
            '<span class="sh-bp__edit">' + esc(T('edit', 'Change')) + '</span></button>';
          if (isOpen) {
            html += '<div class="sh-bp__opts">';
            var order = P.options.map(function (_, i) { return i; });
            if (colourIdx > 0) { order.splice(colourIdx, 1); order.unshift(colourIdx); }
            order.forEach(function (i) {
              var vals = optValues(i);
              if (vals.length === 1 && vals[0] === 'Default Title') return;   /* not a choice */
              html += '<div class="sh-opt"><div class="sh-opt__head"><p class="sh-opt__label">' + esc(optName(i)) + (i === colourIdx ? ' <span>' + esc(o[i]) + '</span>' : '') + '</p></div>';
              html += '<div class="' + (i === colourIdx ? 'sh-swatches' : 'sh-sizes') + '" role="group" aria-label="' + esc(optName(i)) + '">' + optValues(i).map(function (val) {
                var t = o.slice(); t[i] = val; var cand = match(t), any = P.variants.some(function (x) { return x.available && x.o[i] === val; });
                var dis = i === colourIdx ? !any : !(cand && cand.available);
                return i === colourIdx
                  ? '<button type="button" class="sh-swatch" data-bp-opt="' + i + '" data-val="' + esc(val) + '" aria-pressed="' + (o[i] === val) + '" aria-label="' + esc(val) + '" title="' + esc(val) + '" style="' + esc(swatchStyle(val)) + '"' + (dis ? ' disabled' : '') + '></button>'
                  : '<button type="button" class="sh-size" data-bp-opt="' + i + '" data-val="' + esc(val) + '" aria-pressed="' + (o[i] === val) + '"' + (dis ? ' disabled' : '') + '>' + optHtml(i, val) + '</button>';
              }).join('') + '</div></div>';
            });
            if (slots.length > 1) html += '<button type="button" class="sh-bp__remove" data-bp-remove="' + n + '">' + esc(T('remove', 'Remove')) + '</button>';
            html += '</div>';
          }
          html += '</section>';
        });
        bodyEl.innerHTML = html;

        var units = [], ok = true;
        slots.forEach(function (o) { var v = match(o); if (v && v.available) units.push(v.price); else ok = false; });
        var orig = units.reduce(function (a, c) { return a + c; }, 0), save = bundleSavingUnits(tiers, units);
        var next = null;
        tierBtns.forEach(function (b) { var m = parseInt(b.getAttribute('data-min'), 10) || 0; if (m > slots.length && m <= MAX && (!next || m < next.m)) next = { m: m, text: b.getAttribute('data-value') || '' }; });
        footEl.innerHTML =
          (next ? '<button type="button" class="sh-bp__more" data-bp-more="' + (next.m - slots.length) + '"><span aria-hidden="true">+</span> ' + esc(T('more', 'Add [n] more:').replace('[n]', next.m - slots.length)) + ' <b>' + esc(next.text) + '</b></button>' : '') +
          '<div class="sh-bp__sum">' + (save ? '<span class="sh-bp__save">' + esc(T('save', 'You save [amount]').replace('[amount]', money(save, CUR, LOC, SAMPLE))) + '</span>' : '<span></span>') +
          '<span class="sh-bp__total">' + (save ? '<s>' + money(orig, CUR, LOC, SAMPLE) + '</s> ' : '') + '<b>' + money(orig - save, CUR, LOC, SAMPLE) + '</b></span></div>' +
          '<button type="button" class="sh-btn sh-btn--lg sh-btn--block" data-bp-add' + (ok ? '' : ' disabled') + '>' + esc(editing ? T('update', 'Update cart') : T('add', 'Add [n] to cart').replace('[n]', slots.length)) + ' — ' + money(orig - save, CUR, LOC, SAMPLE) + '</button>';
      }

      bp.onclick = function (e) {
        var t;
        if (e.target.closest('[data-bp-close]')) { bp._close(); return; }
        if ((t = e.target.closest('[data-bp-toggle]'))) { var n = +t.getAttribute('data-bp-toggle'); openIdx = openIdx === n ? -1 : n; draw(); return; }
        if ((t = e.target.closest('[data-bp-opt]')) && !t.disabled) {
          var i = +t.getAttribute('data-bp-opt'), o = slots[openIdx]; o[i] = t.getAttribute('data-val');
          if (!match(o) || !match(o).available) { var alt = P.variants.filter(function (v) { return v.available && v.o[i] === o[i]; })[0]; if (alt) { o.length = 0; alt.o.forEach(function (x) { o.push(x); }); } }
          draw(); return;
        }
        if ((t = e.target.closest('[data-bp-remove]'))) { slots.splice(+t.getAttribute('data-bp-remove'), 1); openIdx = Math.min(openIdx, slots.length - 1); draw(); return; }
        if ((t = e.target.closest('[data-bp-more]'))) { var add = +t.getAttribute('data-bp-more'); for (var k = 0; k < add && slots.length < MAX; k++) slots.push(slots[slots.length - 1].slice()); openIdx = slots.length - add; draw(); return; }
        if ((t = e.target.closest('[data-bp-add]')) && !t.disabled) {
          /* a normal /cart/add form, so the site-wide interceptor adds everything in one request and opens the cart */
          var byId = {}; slots.forEach(function (o) { var v = match(o); if (v) byId[v.id] = (byId[v.id] || 0) + 1; });
          if (editing) {
            var updates = {}; cartIds.forEach(function (id) { updates[id] = 0; }); Object.keys(byId).forEach(function (id) { updates[id] = byId[id]; });
            t.disabled = true;
            fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: updates }) })
              .then(function (r) { return r.json(); })
              .then(function () { bpSaved = null; bp.classList.remove('is-open'); lock(false); var c = document.querySelector('[data-cart-open]'); if (c) c.click(); })
              .catch(function () { t.disabled = false; });
            return;
          }
          var f = document.createElement('form'); f.method = 'post'; f.action = '/cart/add'; f.hidden = true; var h = '', n2 = 0;
          Object.keys(byId).forEach(function (id) { h += '<input name="items[' + n2 + '][id]" value="' + id + '"><input name="items[' + n2 + '][quantity]" value="' + byId[id] + '">'; n2++; });
          f.innerHTML = h + '<button type="submit"></button>'; document.body.appendChild(f);
          t.disabled = true;
          if (f.requestSubmit) f.requestSubmit(); else f.querySelector('button').click();
          setTimeout(function () { f.remove(); }, 4000);
        }
      };
      draw();
      bp.classList.add('is-open'); lock(true);
      var x = bp.querySelector('[data-bp-close].sh-iconbtn'); if (x) x.focus();
    }
    if (qtyInput) { qtyInput.addEventListener('change', paintTiers); qtyInput.addEventListener('input', paintTiers); }
    paintTiers();
    if (qtyInput) { qtyInput.addEventListener('change', paint); qtyInput.addEventListener('input', paint); }
    form.addEventListener('submit', function (e) {
      if (!complete()) {
        e.preventDefault(); e.stopImmediatePropagation();
        var miss = missingIdx();
        setStatus(errEl, miss === sizeIdx || miss < 0 ? errEl.getAttribute('data-msg') : fill(errEl.getAttribute('data-msg-option') || 'Choose a [option] before adding to cart.', miss));
        var first = root.querySelector('[data-opt="' + miss + '"]:not([disabled])'); if (first) first.focus();
      }
    }, true);
    document.addEventListener('sh:added', function () {
      var v = match(sel); var q = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    });
    document.addEventListener('sh:adderror', function (e) { setStatus(errEl, e.detail.description || e.detail.message); });
    if (stickyBtn) stickyBtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.querySelector('[type=submit]').click(); });

    /* sticky bar appears once the real button has left the viewport */
    if (sticky && ctaBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var en = entries[0];
        var above = en.boundingClientRect.bottom < 0;
        sticky.classList.toggle('is-on', !en.isIntersecting && above);
      }, { threshold: 0 });
      io.observe(ctaBtn);
    }

    /* gallery */
    var gal = root.querySelector('[data-gallery]');
    var track = gal && gal.querySelector('[data-gal-track]');
    var items = track ? Array.prototype.slice.call(track.children) : [];
    var thumbs = gal ? gal.querySelectorAll('[data-gal-thumb]') : [];
    var dots = gal ? gal.querySelectorAll('[data-gal-dot]') : [];
    function current() { if (!track) return 0; var w = track.clientWidth || 1; return Math.round(track.scrollLeft / w); }
    function paintGal() {
      var i = current();
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      var t = thumbs[i]; if (t && t.scrollIntoView && !reduce) { try { t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {} }
    }
    function goTo(i) { if (!track || !items.length) return; i = (i + items.length) % items.length; track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }
    function jumpTo(mediaId) {
      var i = -1; items.forEach(function (el, n) { if (String(el.getAttribute('data-media-id')) === String(mediaId)) i = n; });
      if (i > -1 && i !== current()) goTo(i);
    }
    if (track) {
      var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(paintGal, 80); }, { passive: true });
      thumbs.forEach(function (b, n) { b.addEventListener('click', function () { goTo(n); }); });
      dots.forEach(function (b, n) { b.addEventListener('click', function () { goTo(n); }); });
      var prev = gal.querySelector('[data-gal-prev]'), next = gal.querySelector('[data-gal-next]');
      if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
      if (next) next.addEventListener('click', function () { goTo(current() + 1); });
      paintGal();
    }

    /* size guide dialog */
    var dlg = root.querySelector('[data-guide]');
    root.querySelectorAll('[data-guide-open]').forEach(function (b) {
      b.addEventListener('click', function () { if (!dlg) return; if (dlg.showModal) { dlg.showModal(); } else { dlg.setAttribute('open', ''); } });
    });
    if (dlg) {
      dlg.querySelectorAll('[data-guide-close]').forEach(function (b) { b.addEventListener('click', function () { dlg.close ? dlg.close() : dlg.removeAttribute('open'); }); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    }

    paint();
  }

  /* ---------- colour editorial tiles → PDP selection ---------- */
  function colourTiles(root) {
    if (bound(root)) return;
    root.querySelectorAll('[data-pick-colour]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        root.querySelectorAll('[data-pick-colour]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        document.dispatchEvent(new CustomEvent('sh:pickcolour', { detail: b.getAttribute('data-pick-colour') }));
        var top = document.querySelector('[data-pdp]');
        if (top && b.getAttribute('data-scroll') === 'true') top.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
    document.addEventListener('sh:variant', function (e) {
      root.querySelectorAll('[data-pick-colour]').forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-pick-colour') === e.detail.colour ? 'true' : 'false'); });
    });
  }

  /* ---------- newsletter: keep the visitor on the page ---------- */
  function newsletter(form) {
    if (bound(form)) return;
    var msg = form.parentElement.querySelector('[data-form-msg]');
    form.addEventListener('submit', function () {
      /* Shopify's customer form must post natively; we only surface the result on return */
    });
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.get('customer_posted') === 'true' && msg) { msg.textContent = msg.getAttribute('data-ok'); msg.className = 'sh-form__msg sh-form__msg--ok'; msg.hidden = false; }
    } catch (e) {}
  }

  /* ---------- product card swatches: swap the card image to that colour ---------- */
  function cardSwatches() {
    if (document.documentElement.getAttribute('data-sh-cards')) return;
    document.documentElement.setAttribute('data-sh-cards', '1');
    document.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-card-swatch]'); if (!sw) return;
      e.preventDefault();
      var card = sw.closest('.sh-card'); if (!card) return;
      card.querySelectorAll('[data-card-swatch]').forEach(function (x) { x.classList.toggle('is-active', x === sw); });
      var img = card.querySelector('.sh-card__img img'), src = sw.getAttribute('data-img');
      if (img && src) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = src; card.classList.add('is-swatched'); }
      var url = sw.getAttribute('data-url');
      if (url) card.querySelectorAll('.sh-card__img, .sh-card__title a').forEach(function (a) { a.href = url; });
      var q = card.querySelector('[data-quick-add]'); if (q) q.setAttribute('data-quick-colour', sw.getAttribute('data-colour'));
    });
  }

  /* ---------- quick add ----------
     Single-variant products go straight into the cart. Anything with options opens a small
     panel (drawer on desktop, bottom sheet on mobile) that reads /products/<handle>.js, so the
     options, stock and prices are always the live ones for the visitor's market. The add
     itself is a normal /cart/add form, so the bag drawer takes over from there. */
  function quickAdd() {
    if (document.documentElement.getAttribute('data-sh-quick')) return;
    document.documentElement.setAttribute('data-sh-quick', '1');
    var panel = null, body = null, opener = null;
    function sample() { var c = document.querySelector('[data-cart]'); return c ? c.getAttribute('data-money-sample') : ''; }
    function cur() { var c = document.querySelector('[data-cart]'); return c ? c.getAttribute('data-currency') : 'USD'; }
    /* same rule as the product page: US/CA see inches first, everyone else centimetres first */
    function imperial() { var c = document.querySelector('[data-cart]'); return !!c && c.getAttribute('data-units') === 'imperial'; }
    function sizeLabel(val) {
      var m = String(val).match(/^\s*(\d+(?:[.,]\d+)?)\s*[×x]\s*(\d+(?:[.,]\d+)?)\s*cm\s*$/i);
      if (!m) return '<b>' + esc(val) + '</b>';
      var inch = Math.round(parseFloat(m[1].replace(',', '.')) / 2.54) + ' × ' + Math.round(parseFloat(m[2].replace(',', '.')) / 2.54) + ' in';
      return imperial() ? '<b>' + inch + '</b><span>' + esc(val) + '</span>' : '<b>' + esc(val) + '</b><span>' + inch + '</span>';
    }
    function submitVariant(id, qty) {
      var f = document.createElement('form'); f.method = 'post'; f.action = '/cart/add'; f.hidden = true;
      f.innerHTML = '<input name="id" value="' + id + '"><input name="quantity" value="' + (qty || 1) + '"><button type="submit"></button>';
      document.body.appendChild(f);
      if (f.requestSubmit) f.requestSubmit(); else f.querySelector('button').click();
      setTimeout(function () { f.remove(); }, 4000);
    }
    function build() {
      panel = document.createElement('div'); panel.className = 'sh sh-qa';
      panel.innerHTML = '<div class="sh-qa__scrim" data-qa-close></div>' +
        '<aside class="sh-qa__panel" role="dialog" aria-modal="true" aria-label="Quick add">' +
        '<div class="sh-qa__top"><h2>Quick add</h2><button type="button" class="sh-iconbtn" data-qa-close aria-label="Close">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button></div>' +
        '<div class="sh-qa__body" data-qa-body></div></aside>';
      document.body.appendChild(panel);
      body = panel.querySelector('[data-qa-body]');
      panel.addEventListener('click', function (e) { if (e.target.closest('[data-qa-close]')) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('is-open')) close(); });
      document.addEventListener('sh:added', function () { if (panel.classList.contains('is-open')) { panel.classList.remove('is-open'); } });
    }
    function close() { panel.classList.remove('is-open'); lock(false); if (opener && opener.focus) opener.focus(); }
    function render(p, wantColour) {
      var S = sample(), C = cur();
      var opts = p.options.map(function (o) { return { name: o.name, values: o.values }; });
      var colourIdx = -1;
      opts.forEach(function (o, i) { var n = String(o.name).toLowerCase(); if (n === 'color' || n === 'colour') colourIdx = i; });
      var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      var sel = first.options.slice();
      if (wantColour && colourIdx > -1) {
        var vc = p.variants.filter(function (v) { return v.options[colourIdx] === wantColour && v.available; })[0];
        if (vc) sel = vc.options.slice();
      }
      function match(s) { return p.variants.filter(function (v) { return v.options.every(function (x, i) { return x === s[i]; }); })[0] || null; }
      function imgFor(value) {
        var v = p.variants.filter(function (x) { return x.options[colourIdx] === value && x.featured_image; })[0];
        return v ? v.featured_image.src : '';
      }
      function sized(src, w) { return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
      var html = '<div class="sh-qa__head"><div class="sh-qa__img"><img data-qa-img alt=""></div><div>' +
        '<p class="sh-qa__title">' + esc(p.title) + '</p>' +
        '<div class="sh-price"><span class="sh-price__was" data-qa-was hidden></span><span class="sh-price__now" data-qa-now></span></div>' +
        '<a class="sh-link" href="' + esc(p.url || ('/products/' + p.handle)) + '">View full details</a></div></div>';
      var order = opts.map(function (o, i) { return i; });
      if (colourIdx > 0) { order.splice(colourIdx, 1); order.unshift(colourIdx); }
      order.forEach(function (i) {
        var o = opts[i];
        html += '<div class="sh-opt"><div class="sh-opt__head"><p class="sh-opt__label">' + esc(o.name) + ' <span data-qa-name="' + i + '"></span></p></div>';
        if (i === colourIdx) {
          html += '<div class="sh-qa__sws" role="group" aria-label="' + esc(o.name) + '">' + o.values.map(function (val) {
            var src = imgFor(val);
            return '<button type="button" class="sh-qa__sw" data-qa-opt="' + i + '" data-val="' + esc(val) + '" aria-pressed="false" aria-label="' + esc(val) + '" title="' + esc(val) + '">' + (src ? '<img src="' + esc(sized(src, 120)) + '" alt="">' : '') + '</button>';
          }).join('') + '</div>';
        } else {
          html += '<div class="sh-sizes" role="group" aria-label="' + esc(o.name) + '">' + o.values.map(function (val) {
            return '<button type="button" class="sh-size" data-qa-opt="' + i + '" data-val="' + esc(val) + '" aria-pressed="false">' + sizeLabel(val) + '</button>';
          }).join('') + '</div>';
        }
        html += '</div>';
      });
      html += '<button type="button" class="sh-btn sh-btn--lg sh-btn--block" data-qa-add>Add to cart</button>';
      body.innerHTML = html;
      function paint() {
        var v = match(sel);
        body.querySelectorAll('[data-qa-opt]').forEach(function (b) {
          var i = +b.getAttribute('data-qa-opt'), val = b.getAttribute('data-val');
          b.setAttribute('aria-pressed', sel[i] === val ? 'true' : 'false');
          var t = sel.slice(); t[i] = val; var cand = match(t);
          b.disabled = !cand || !cand.available;
        });
        opts.forEach(function (o, i) { var n = body.querySelector('[data-qa-name="' + i + '"]'); if (n) n.textContent = i === colourIdx ? sel[i] : ''; });
        var now = body.querySelector('[data-qa-now]'), was = body.querySelector('[data-qa-was]'), btn = body.querySelector('[data-qa-add]');
        if (v) {
          now.textContent = money(v.price, C, 'en', S);
          if (v.compare_at_price && v.compare_at_price > v.price) { was.textContent = money(v.compare_at_price, C, 'en', S); was.hidden = false; } else was.hidden = true;
          btn.disabled = !v.available;
          btn.textContent = v.available ? 'Add to cart — ' + money(v.price, C, 'en', S) : 'Sold out';
          var src = (v.featured_image && v.featured_image.src) || (colourIdx > -1 ? imgFor(sel[colourIdx]) : '') || (p.featured_image || '');
          body.querySelector('[data-qa-img]').src = sized(src, 300);
        } else { btn.disabled = true; btn.textContent = 'Unavailable'; }
      }
      body.addEventListener('click', function (e) {
        var b = e.target.closest('[data-qa-opt]');
        if (b && !b.disabled) {
          var i = +b.getAttribute('data-qa-opt'); sel[i] = b.getAttribute('data-val');
          if (!match(sel) || !match(sel).available) {
            var alt = p.variants.filter(function (v) { return v.available && v.options[i] === sel[i]; })[0];
            if (alt) sel = alt.options.slice();
          }
          paint(); return;
        }
        if (e.target.closest('[data-qa-add]')) { var v = match(sel); if (v && v.available) submitVariant(v.id, 1); }
      });
      paint();
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-quick-add]'); if (!b) return;
      e.preventDefault(); opener = b;
      var vid = b.getAttribute('data-quick-variant');
      if (vid) { submitVariant(vid, 1); return; }
      var handle = b.getAttribute('data-quick-add');
      b.classList.add('is-loading');
      fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          b.classList.remove('is-loading');
          if (!panel) build();
          render(p, b.getAttribute('data-quick-colour'));
          panel.classList.add('is-open'); lock(true);
          var x = panel.querySelector('[data-qa-close].sh-iconbtn'); if (x) x.focus();
        })
        .catch(function () { window.location.href = '/products/' + handle; });
    });
  }

  /* ---------- the wordmark returns you to the top on the home page ---------- */
  function logoTop(logo) {
    if (bound(logo)) return;
    logo.addEventListener('click', function (e) {
      var trim = function (s) { return s.replace(/\/$/, ''); };
      if (trim(window.location.pathname) !== trim(new URL(logo.href, window.location.href).pathname)) return;
      e.preventDefault();
      var how = { top: 0, behavior: reduce ? 'auto' : 'smooth' };
      window.scrollTo(how);
      document.querySelectorAll('.page-wrapper').forEach(function (el) { if (el.scrollTop) el.scrollTo(how); });
    });
  }

  /* ---------- footer columns: always open on desktop, accordions on mobile ----------
     They render open so desktop and no-JS visitors see every link; on small screens they
     start closed. A closed <details> cannot be revealed with CSS, so this is done here. */
  function footerAcc() {
    var list = document.querySelectorAll('[data-footer-acc]'); if (!list.length) return;
    var mq = window.matchMedia('(max-width: 768px)');
    function apply() { list.forEach(function (d) { if (mq.matches) d.removeAttribute('open'); else d.setAttribute('open', ''); }); }
    apply();
    if (!document.documentElement.getAttribute('data-sh-footacc')) {
      document.documentElement.setAttribute('data-sh-footacc', '1');
      if (mq.addEventListener) mq.addEventListener('change', apply); else if (mq.addListener) mq.addListener(apply);
    }
    list.forEach(function (d) {
      var sum = d.querySelector('summary');
      if (sum && !sum.getAttribute('data-bound')) { sum.setAttribute('data-bound', '1'); sum.addEventListener('click', function (e) { if (!mq.matches) e.preventDefault(); }); }
    });
  }

  /* Shop the look: one open hotspot card at a time; closes on outside click or Escape. */
  function hotspots(fig) {
    if (fig.getAttribute('data-bound')) return; fig.setAttribute('data-bound', '1');
    var spots = fig.querySelectorAll('.sh-hs');
    function close(except) {
      spots.forEach(function (s) { if (s === except) return; s.classList.remove('is-open'); var b = s.querySelector('.sh-hs__btn'); if (b) b.setAttribute('aria-expanded', 'false'); });
    }
    spots.forEach(function (s) {
      var btn = s.querySelector('.sh-hs__btn'); if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = !s.classList.contains('is-open');
        close(s);
        s.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    document.addEventListener('click', function (e) { if (!fig.contains(e.target) || !e.target.closest('.sh-hs')) close(null); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var o = fig.querySelector('.sh-hs.is-open'); if (!o) return;
      close(null); var b = o.querySelector('.sh-hs__btn'); if (b) b.focus();
    });
  }

  /* Announcement bar: messages slide in from the right and out to the left; pauses on hover or keyboard focus. */
  function announce(bar) {
    if (bar.getAttribute('data-bound')) return; bar.setAttribute('data-bound', '1');
    var msgs = bar.querySelectorAll('.sh-announce__msg'); if (msgs.length < 2) return;
    var i = 0, paused = false, ms = parseInt(bar.getAttribute('data-interval'), 10) || 4000;
    function show(n) {
      msgs.forEach(function (m, k) {
        var a = m.querySelector('a');
        if (k === n) {
          m.classList.remove('is-out'); m.classList.add('is-on');
          m.removeAttribute('aria-hidden'); if (a) a.removeAttribute('tabindex');
          return;
        }
        if (m.classList.contains('is-on')) {
          /* slide the current message out to the left, then park it off-screen right again */
          m.classList.remove('is-on'); m.classList.add('is-out');
          setTimeout(function () { m.classList.remove('is-out'); }, 700);
        }
        m.setAttribute('aria-hidden', 'true'); if (a) a.setAttribute('tabindex', '-1');
      });
    }
    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    bar.addEventListener('focusin', function () { paused = true; });
    bar.addEventListener('focusout', function () { paused = false; });
    setInterval(function () { if (paused || document.hidden) return; i = (i + 1) % msgs.length; show(i); }, ms);
  }

  /* Reviews: collapse to the first batch on wider screens; the button reveals the rest. */
  function reviewsMore(wrap) {
    if (bound(wrap)) return;
    var btn = wrap.parentNode.querySelector('[data-reviews-more]');
    if (!btn || !wrap.querySelector('.sh-rev.is-extra')) return;
    wrap.classList.add('is-collapsed');
    btn.addEventListener('click', function () {
      var collapsed = wrap.classList.toggle('is-collapsed');
      btn.textContent = collapsed ? (btn.getAttribute('data-more') || 'Show more') : (btn.getAttribute('data-less') || 'Show less');
      if (collapsed) wrap.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function init() {
    document.querySelectorAll('[data-announce]').forEach(announce);
    document.querySelectorAll('[data-reviews]').forEach(reviewsMore);
    document.querySelectorAll('[data-hotspots]').forEach(hotspots);
    document.querySelectorAll('[data-sh-header]').forEach(menu);
    document.querySelectorAll('[data-loc]').forEach(loc);
    document.querySelectorAll('[data-geo]').forEach(geo);
    document.querySelectorAll('[data-hero]').forEach(hero);
    document.querySelectorAll('[data-tabs]').forEach(tabs);
    document.querySelectorAll('[data-rail]').forEach(rail);
    document.querySelectorAll('[data-qty]').forEach(qty);
    document.querySelectorAll('[data-pdp]').forEach(pdp);
    document.querySelectorAll('[data-colour-tiles]').forEach(colourTiles);
    document.querySelectorAll('[data-newsletter]').forEach(newsletter);
    document.querySelectorAll('.sh-wordmark').forEach(logoTop);
    cardSwatches();
    quickAdd();
    footerAcc();
    bag();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
